import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisCsvUploadDetailFragment = { __typename?: 'HrisCsvUpload', id: string, createdAt: string, updatedAt: string, selectedColumnsAt?: string | null, dataVerifiedAt?: string | null, appliedAt?: string | null, startedCreatingObjectsAt?: string | null, finishedCreatingObjectsAt?: string | null, modifiedEmployeesCount: number, idField?: string | null, firstNameField?: string | null, firstNameFallbackField?: string | null, lastNameField?: string | null, lastNameFallbackField?: string | null, nameField?: string | null, locationField?: string | null, teamField?: string | null, phoneField?: string | null, phoneFallbackField?: string | null, terminationDateField?: string | null, startDateField?: string | null, csvRawText: string, csvUrl: string, uploadedBy?: { __typename?: 'Employee', id: number, name: string } | null, locationGroup?: { __typename?: 'LocationGroup', id: string, name: string } | null, org: { __typename?: 'Org', id: number } };

export type HrisCsvUploadSidebarQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type HrisCsvUploadSidebarQuery = { __typename?: 'Query', HrisCsvUpload?: { __typename?: 'HrisCsvUpload', id: string, createdAt: string, updatedAt: string, selectedColumnsAt?: string | null, dataVerifiedAt?: string | null, appliedAt?: string | null, startedCreatingObjectsAt?: string | null, finishedCreatingObjectsAt?: string | null, modifiedEmployeesCount: number, idField?: string | null, firstNameField?: string | null, firstNameFallbackField?: string | null, lastNameField?: string | null, lastNameFallbackField?: string | null, nameField?: string | null, locationField?: string | null, teamField?: string | null, phoneField?: string | null, phoneFallbackField?: string | null, terminationDateField?: string | null, startDateField?: string | null, csvRawText: string, csvUrl: string, uploadedBy?: { __typename?: 'Employee', id: number, name: string } | null, locationGroup?: { __typename?: 'LocationGroup', id: string, name: string } | null, org: { __typename?: 'Org', id: number } } | null };

export const HrisCsvUploadDetailFragmentDoc = gql`
    fragment HrisCsvUploadDetail on HrisCsvUpload {
  id
  createdAt
  updatedAt
  uploadedBy {
    id
    name
  }
  locationGroup {
    id
    name
  }
  selectedColumnsAt
  dataVerifiedAt
  appliedAt
  startedCreatingObjectsAt
  finishedCreatingObjectsAt
  modifiedEmployeesCount
  idField
  firstNameField
  firstNameFallbackField
  lastNameField
  lastNameFallbackField
  nameField
  locationField
  teamField
  phoneField
  phoneFallbackField
  terminationDateField
  startDateField
  csvRawText
  csvUrl
  org {
    id
  }
}
    `;
export const HrisCsvUploadSidebarDocument = gql`
    query HrisCsvUploadSidebar($id: UUID!) {
  HrisCsvUpload(id: $id) {
    ...HrisCsvUploadDetail
  }
}
    ${HrisCsvUploadDetailFragmentDoc}`;

/**
 * __useHrisCsvUploadSidebarQuery__
 *
 * To run a query within a React component, call `useHrisCsvUploadSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisCsvUploadSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisCsvUploadSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHrisCsvUploadSidebarQuery(baseOptions: Apollo.QueryHookOptions<HrisCsvUploadSidebarQuery, HrisCsvUploadSidebarQueryVariables> & ({ variables: HrisCsvUploadSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisCsvUploadSidebarQuery, HrisCsvUploadSidebarQueryVariables>(HrisCsvUploadSidebarDocument, options);
      }
export function useHrisCsvUploadSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisCsvUploadSidebarQuery, HrisCsvUploadSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisCsvUploadSidebarQuery, HrisCsvUploadSidebarQueryVariables>(HrisCsvUploadSidebarDocument, options);
        }
export type HrisCsvUploadSidebarQueryHookResult = ReturnType<typeof useHrisCsvUploadSidebarQuery>;
export type HrisCsvUploadSidebarLazyQueryHookResult = ReturnType<typeof useHrisCsvUploadSidebarLazyQuery>;
export type HrisCsvUploadSidebarQueryResult = Apollo.QueryResult<HrisCsvUploadSidebarQuery, HrisCsvUploadSidebarQueryVariables>;